var _a;
import { twMerge } from 'tailwind-merge';
import React from 'react';
import '../../../utils/Flows';
import { THEME } from '../../../../clearstep/util/Theme';
import { MobileStates } from '../../Widget';
import WidgetHeaderContent from './WidgetHeaderContent';
import WidgetHeaderContentSingleFlowWithExit from './WidgetHeaderContentSingleFlowWithExit';
import WidgetHeaderContentSingleFlow from './WidgetHeaderContentSingleFlow';
var customTheme = ((_a = THEME.widgetCustomizations) === null || _a === void 0 ? void 0 : _a.widgetHeaderTheme) || {};
export var WidgetHeader = function (props) {
    var setWorkflow = props.setWorkflow, className = props.className, headerText = props.headerText, singleFlow = props.singleFlow, setWidgetState = props.setWidgetState, mobileState = props.mobileState;
    var isSingleFlow = !!singleFlow;
    var isSingleFlowMobile = isSingleFlow && mobileState === MobileStates.MOBILE;
    return (React.createElement("div", { className: twMerge('flex items-center justify-between rounded-t-2xl border-x-0 border-b border-t-0 border-solid border-gray-300', isSingleFlowMobile
            ? 'h-widget-extended-header' /* Need more header room for 2 rows */
            : 'h-widget-header', className), style: {
            backgroundColor: customTheme.backgroundColor || 'white',
        } }, isSingleFlow ? (isSingleFlowMobile ? (React.createElement(WidgetHeaderContentSingleFlowWithExit, { setWorkflow: setWorkflow, headerText: headerText, setWidgetState: setWidgetState, mobileState: mobileState })) : (React.createElement(WidgetHeaderContentSingleFlow, { headerText: headerText }))) : (React.createElement(WidgetHeaderContent, { setWorkflow: setWorkflow, headerText: headerText }))));
};
